import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('sharedLinksV2');

export default resourceActions;
